var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgA2GridDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 772,
    height: 691,
    viewBox: "0 0 772 691",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(0.866041 0.499972 -0.866041 0.499972 -964.251 554.109)",
    stroke: "#8492C4"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(-0.866041 0.499972 -0.866041 -0.499972 6.39597 8.06567)",
    stroke: "#8492C4"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(0.866041 0.499972 -0.866041 0.499972 -896.683 515.101)",
    stroke: "#8492C4"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(-0.866041 0.499972 -0.866041 -0.499972 73.9637 47.0732)",
    stroke: "#8492C4"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(0.866041 0.499972 -0.866041 0.499972 -829.115 476.094)",
    stroke: "#8492C4"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(-0.866041 0.499972 -0.866041 -0.499972 141.532 86.0803)",
    stroke: "#8492C4"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(0.866041 0.499972 -0.866041 0.499972 -761.547 437.086)",
    stroke: "#8492C4"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(-0.866041 0.499972 -0.866041 -0.499972 209.099 125.088)",
    stroke: "#8492C4"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(0.866041 0.499972 -0.866041 0.499972 -693.979 398.079)",
    stroke: "#8492C4"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(-0.866041 0.499972 -0.866041 -0.499972 276.667 164.096)",
    stroke: "#8492C4"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(0.866041 0.499972 -0.866041 0.499972 -626.412 359.072)",
    stroke: "#8492C4"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(-0.866041 0.499972 -0.866041 -0.499972 344.235 203.103)",
    stroke: "#8492C4"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(0.866041 0.499972 -0.866041 0.499972 -558.844 320.064)",
    stroke: "#8492C4"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(-0.866041 0.499972 -0.866041 -0.499972 411.803 242.111)",
    stroke: "#8492C4"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(0.866041 0.499972 -0.866041 0.499972 -491.276 281.057)",
    stroke: "#8492C4"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(-0.866041 0.499972 -0.866041 -0.499972 479.371 281.118)",
    stroke: "#8492C4"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(0.866041 0.499972 -0.866041 0.499972 -423.709 242.05)",
    stroke: "#8492C4"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(-0.866041 0.499972 -0.866041 -0.499972 546.939 320.125)",
    stroke: "#8492C4"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(0.866041 0.499972 -0.866041 0.499972 -356.142 203.042)",
    stroke: "#8492C4"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(-0.866041 0.499972 -0.866041 -0.499972 614.506 359.133)",
    stroke: "#8492C4"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(0.866041 0.499972 -0.866041 0.499972 -288.574 164.035)",
    stroke: "#8492C4"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(-0.866041 0.499972 -0.866041 -0.499972 682.074 398.14)",
    stroke: "#8492C4"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(0.866041 0.499972 -0.866041 0.499972 -221.006 125.027)",
    stroke: "#8492C4"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(-0.866041 0.499972 -0.866041 -0.499972 749.642 437.148)",
    stroke: "#8492C4"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(0.866041 0.499972 -0.866041 0.499972 -153.438 86.0198)",
    stroke: "#8492C4"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(-0.866041 0.499972 -0.866041 -0.499972 817.21 476.155)",
    stroke: "#8492C4"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(0.866041 0.499972 -0.866041 0.499972 -85.9754 47.0732)",
    stroke: "#8492C4"
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(-0.866041 0.499972 -0.866041 -0.499972 884.778 515.163)",
    stroke: "#8492C4"
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(0.866041 0.499972 -0.866041 0.499972 -18.4076 8.06567)",
    stroke: "#8492C4"
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1120.91,
    y2: -0.5,
    transform: "matrix(-0.866041 0.499972 -0.866041 -0.499972 952.346 554.17)",
    stroke: "#8492C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgA2GridDark);
export default __webpack_public_path__ + "static/media/img-a2-grid-dark.ed153a91eb0e88361ba4b72aaa54d385.svg";
export { ForwardRef as ReactComponent };